const korean = {
  hello: 'hello',
  chooseStatus: '선택됨',
  timeTitle: '이벤트마감일카운트다운',
  timeTitle1: '활동이 종료됨',
  timeTitle2: '활동이 시작되지 않았습니다',
  days: '일',
  hour: '시',
  minute: '분',
  second: '초',
  allNumsName: '총 표수',
  playnumsName: '후보 수',
  votenumsName: '조회 수',
  voteStart: '투표 시작',
  voteEnd: '투표 종료',
  voteRule: '투표 규칙',
  activeRule: '선정 규칙',
  searchTip: '선수 번호 또는 명칭을 입력하십시오',
  searchBtn: '검색',
  vote: '투표',
  playerNo: '번호',
  introduce: '소개',
  activeIntroduce: '이벤트 소개',
  rank: '순위',
  rankName: '랭킹',
  rankName2: '순위',
  voteNums: '표수',
  voteUnit: '표',
  infoBtn: '상세 정보',
  loadding: '로드 중···',
  noDesc: '소개 없음',
  lastNext: '상위 1명까지',
  numbers: '표수',
  helpme: '저를 위해 표를 긁어모아주십시오',
  report: '고발',
  first: '일등',
  now: '현재',
  change: '언어 전환',
  share1: '오른쪽 상단을 클릭하세요',
  share2: '지정된 친구에게 보내기',
  share3: '또는 모멘트에 공유',
  rules: '각 위챗 계정은 하루에 5표를 투표할 수 있으며 같은 선수에게 투표할 수 없습니다。',
  all: '모두',
}
export default korean